import './nav.less'

document.addEventListener('DOMContentLoaded', () => {
    // Hide tooltip when bottom main menu items clicked
    const menuTooltips = [].slice.call(
        document.querySelectorAll('.main-navigation-bottom [data-uk-tooltip]')
    )
    menuTooltips.forEach((element: HTMLElement) => {
        element.addEventListener('click', () => {
            const active = document.querySelector(
                '.uk-tooltip.uk-active'
            ) as HTMLDivElement
            if (active) {
                active.style.display = 'none'
            }
        })
    })
})
